import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "view-reset-password" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_password_reset_form = _resolveComponent("password-reset-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_password_reset_form, _mergeProps({ class: "view-reset-password__form" }, { token: _ctx.token, errors: _ctx.errors }, {
      loading: _ctx.isLoading,
      onSubmit: _ctx.resetPassword
    }), null, 16, ["loading", "onSubmit"])
  ]))
}